import $ from 'jquery'
import { $doc, $body } from '../common';
import { addJqPlugin, transitionCss } from "./helper"
addJqPlugin('transitionCss', transitionCss);

const activeClass = 'menu-is-active';

export default class Menu {

    static of(root) {
        return new Menu(root);
    }

    get active() {
        return this.__active;
    }

    set active(value) {
        this.__active = value;
        this._update();
    }

    constructor(root) {
        this.root = root;
        this.trigger = $('[data-menu-trigger]');
        this.__active = root.hasClass(activeClass);
        this.$items = $('.main-menu__item', root);
        this.mobileClass = '.open-on-mobile';
        this.$content = $('.barba-main').children();
        this.transitionClearTimeout = null;

        this.trigger.on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.active = !this.active;
        });

        $('.screen-overlay').on('click', () => {
            this.active = false;
        });

        $('.main-menu__icon', root).on('click', e => {
            const $item = $(e.target).parent();
            const active = $item.hasClass('is-active');

            $('.main-menu__sublist').stop().slideUp()
                .parent().removeClass('is-active')
                .filter($item.get(0)).toggleClass('is-active', !active)
                .find('.main-menu__sublist')[active ? 'slideUp' : 'slideDown']()
        });

        if(window.matchMedia("(max-width: 1200px)").matches) {
            let element = this.$items.filter(this.mobileClass).get(0);
            $(element).find('.main-menu__icon').trigger('click');
        }
    }

    /**
     * update menu
     * @return {Promise} promise of transition end
     * @private
     */
    _update() {
        return this.root.transitionCss(() => {
            this.root.toggleClass(activeClass, this.active);
            $body.toggleClass(activeClass, this.active);
            if (this.active) {
                clearTimeout(this.transitionClearTimeout);
                this.$content.css({transform: 'translate(320px)', transition: 'transform 0.5s'});
            } else {
                this.$content.css({transform: ''});
                this.transitionClearTimeout = setTimeout(() => {
                    this.$content.css({transition: ''});
                }, 500);
            }


            if (this.active) {
                $doc.on('keypress.menu', e => {
                    switch (e.keyCode) {
                        case 27: // key:: esc
                            this.active = false;
                            break;
                        default: // any key
                            break;
                    }
                });
            } else {
                $doc.off('keypress.menu');
            }
        });
    }

    /**
     * close menu
     * @return {Promise} promise of transition end
     */
    close() {
        this.__active = false;
        return this._update();
    }

    destroy() {
        this.active = false;
        $doc.off('keypress.menu');
    }
}



// WEBPACK FOOTER //
// ./scripts/menu.js